import { ROUTE_NAMES } from '@/lib/enums';

export const routes = [
	{
		path: 'schedules',
		meta: {
			requireAuth: true,
			breadcrumb: 'Schedules',
		},
		children: [
			{
				path: '',
				component: () => {
					return import('@/views/depot/schedules/Overview.vue');
				},
				name: ROUTE_NAMES.DEPOT.SCHEDULES.OVERVIEW,
				meta: {
					requireAuth: true,
					breadcrumb: '',
				},
			},
			{
				path: 'all-jobs',
				component: () => {
					return import('@/views/depot/schedules/All-Jobs.vue');
				},
				name: ROUTE_NAMES.DEPOT.SCHEDULES.ALL_JOBS,
				meta: {
					requireAuth: true,
					breadcrumb: 'All Jobs',
				},
			},
			{
				path: ':schedule_uuid',
				component: () => {
					return import('@/views/depot/schedules/View-Schedule.vue');
				},
				name: ROUTE_NAMES.DEPOT.SCHEDULES.VIEW_SCHEDULE,
				meta: {
					requireAuth: true,
					breadcrumb: 'Schedule',
				},
			},
		],
	},
];
